module.exports = __webpack_public_path__ + "img/nf1图标-4.86a85f20.png";